module.exports = __webpack_public_path__ + "static/media/Remove.278fc44b.svg";